import React from 'react';

// react bootstrap imports
import Container from "react-bootstrap/Container";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUserMd} from '@fortawesome/free-solid-svg-icons'
import {Grid} from '@material-ui/core'

import HomeLinks from "./HomeLinks";
import './home.css'
import messages from "./messages";
import useStyles from './styles'


const Home = ({user, provider, npiNumber}) => {
    const classes = useStyles()
    return (
        <Container id={messages.id}>
            <h1 className="my-5" id={messages.greeting.id}><span>{messages.greeting.getText(user)}</span></h1>
            <h2 className="my-5" id={messages.title.id}>{messages.title.text}</h2>
            <Grid container className={classes.secondaryGreetingWrapper}>
                <FontAwesomeIcon style={{width: '3rem'}} icon={faUserMd} className={classes.personaIcon}/>
                <div style={{padding: '0.3rem'}} className={classes.secondaryGreeting} dangerouslySetInnerHTML={messages.secondaryGreetingHTML(provider, npiNumber)} />
            </Grid>
            <HomeLinks />
            <div className="my-5" id={messages.jobAid.id}>{messages.jobAid.text}<a target="_blank" rel="noopener noreferrer" href={messages.jobAid.link}>{messages.jobAid.linkText}</a></div>
        </Container>
    )
};

export default Home;
